import React, { useState, useEffect } from 'react';
import '../../entrydoor.css';
import { authFetchRequest } from '../../utils/api';
import { getCookie } from '../../utils/cookies';

const AlertDiscount = ({ id = "discount", value, onChange, label = 'Discount (%)', disabled = false }) => {
  const [discountValue, setDiscountValue] = useState(value || 0);
  const [updateMessage, setUpdateMessage] = useState('');

  useEffect(() => {
    setDiscountValue(value || 0);
  }, [value]);

  const handleChange = (e) => {
    const val = e.target.value;
    if (/^\d*$/.test(val)) {  // Allow only integers
      setDiscountValue(val);
      onChange(val); // Notify parent
    }
  };

  const handleUpdate = async () => {
    setUpdateMessage('');
    const userId = getCookie('user_id') || 0;
  
    try {
      const result = await authFetchRequest(
        `/users/${userId}/field/alertDiscount`,
        { value: parseInt(discountValue, 10) },
        'PUT',
        { Authorization: `Bearer ${getCookie("access_token")}` }
      );
      setUpdateMessage(result.message || 'Discount updated ✔️');
    } catch (err) {
      console.error('Discount update failed:', err);
      setUpdateMessage('Failed to update discount ❌');
    }
  };
  

  return (
    <div className="a-container">
      <label htmlFor={id}>{label}</label>
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <input
          type="text"
          disabled={disabled}
          id={id}
          value={discountValue}
          onChange={handleChange}
          className="p-2 border rounded-md w-24 focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
        <button
          onClick={handleUpdate}
          disabled={disabled}
          className="px-3 py-1 bg-green-600 text-white rounded hover:bg-green-700"
        >
          Update
        </button>
      </div>
      {updateMessage && (
        <div style={{ marginTop: '5px', fontSize: '0.85rem', color: updateMessage.includes('✔️') ? 'green' : 'red' }}>
          {updateMessage}
        </div>
      )}
    </div>
  );
};

export default AlertDiscount;
